<template>
  <div id="right-sidebar" class="Hnotificatn--r notification-bell" :class="{'sidebar-open' : show}" style="height: 488px !important;" @click.stop>
    <div class="sidebar--heading">
      <div class="Ntfication_head">
        <h3 style="margin-bottom: 5px;">
          Notifications<br />
        </h3>
        <h3 style="padding-top:0px;margin-bottom: 5px;"><span style="padding: 0px !important;"> Your recent unread notifications will be listed here</span></h3>
      </div>
      <div @click="onClose" class="Ntfication_close pull-right" style="position:absolute; right:10px; top:5px;">
        <a href="javascript:;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/close_Icon.png`" /></a>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="sidebar-container dynamic-enable-scroll" data-scroll-height="400px" id="Hnotifiction_scrollh" style="overflow: auto;">
      <div class="no_notification" v-if="isLoading">
        <ob-spinner loadingText="Loading..."></ob-spinner>
      </div>
      <template v-else-if="notificationList && notificationList.length > 0">
        <div @click="onNotificationClick(n)" class="Hnotification--sec clearfix notification_unread" v-for="(n, index) in notificationList" :key="index">
          <a href="#">
            <img class="img-circle Hnotification-img" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/noimage.svg`" alt="NotificationPic">
          </a>
          <label style="cursor:pointer">
            <span class="Notification-blockview">
              <!-- <a class="Notification-viewmore" v-readMore:111="n.Description"
                @click.stop="'javascript:;'"></a> v-html="n.Description" -->
              <div v-html="getContent(n)" style="display:inline;"></div>
              <!-- <a v-if="n.Description.length > 111" @click.stop="n.Loadmore = !n.Loadmore" style="color:#4a90e2 !important;font-weight: 600;display:inline-block;"> {{n.Loadmore ? 'read more' :'read less'}}</a> -->
            </span>
            <img style="width:12px;margin-right:6px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_timestamp.svg`"/>
              {{n.CreatedDateTime | humantime}}
          </label>
          <small class="unreadNotification pull-right"></small><a href="javascript:;" @click.stop="markAsRead(n.Id);" class="unreadNotification__text">Mark as Read</a>
        </div>
      </template>
      <div class="no_notification" v-else>
        <div class="MT-Content-table">
          <div class="MT-Content">
            <div style="margin-bottom: 20px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_empty_alerts.svg`"></div>
            <div>All caught up!!</div>
          </div>
        </div>
      </div>
    </div>
    <div class="Hnotification--sec text-center" v-if="!isLoading" style="background-color:#E9EDF5;" @click="onRedirectAndClose">
      <a href="/notification" class="HR--more">View All</a>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
import c from '@/components/Core/constants.js'
export default {
  props: ["show"],
  data() {
    return {
      isLoading: true,
      notificationList: [],
      List:[]
    }
  },
  created() {
    this.interval = setInterval(() => {
                this.notificationList = [];
                this.notificationList = this.List;
    }, 1000);
    // Fetch Notification Count
    this.$store.dispatch('fetchUnreadNotificationsCount','sdcsd');
    this.fetch();
  },
  methods: {
    getContent(x)
    {
      if(x.Description){
        return x.Description
      }
      //  if(x.Loadmore && x.Description.length > 111)
      //       {
      //           return x.Description.substring(0,111) + " ";
      //       }
      //       else  return x.Description
    },
    onNotificationClick(data){
      this.markAsRead(data.Id);
      let url = "";
      if(data.Name == "Form I-983") {
        url = `/employee/form-i983`
      }
      else if(data.Name == "Task"){
        if(data.ActivityLog.ReceiverObject.Type == "Supervisor")  {
         let reportingEmpId = data.ActivityLog.ActionObject.CreatedBy.Id
          if(data.ActivityLog.ActivityType == "TaskDeleted"){
              url = `${c.APPLICATIONBASEURL}/ReportingEmployees/employee-tasks-trainee?EmployeeId=${reportingEmpId}&from=ReportingEmployee`
            }
         else{
              let TaskId = data.ActivityLog.ActionObject.Id
              url = `${c.APPLICATIONBASEURL}/employee-tasks-details/${TaskId}?EmployeeId=${reportingEmpId}&from=ReportingEmployee&isListview=true`;
          }
       }
       else{
        if(data.ActivityLog.ActivityType == "TaskDeleted"){
            url = `/employee-tasks/`
        }
         else{
              let TaskId = data.ActivityLog.ActionObject.Id
            url = `${c.APPLICATIONBASEURL}/employee-tasks-details/${TaskId}`;
          }
        }
      }
      else if(data.Name == "Policy Documents"){
        url = `/leave-policy`
      }
      else if(data.Name == "Holiday List"){
        url = `/holiday-list`
      }
      else if(data.Name == "Timesheets" || data.Name == "Leave"){
        var fromDate = data.ActivityLog.ActionObject.Name;
        var email = data.ActivityLog.ActionObject.CreatedBy.Email;
        var empId = data.ActivityLog.ActionObject.CreatedBy.Id;
        if(data.NotificationType == "TimesheetRejected")
        {  
          if(empId == this.loggedInUserObj.empId)   
          {
          url = `/evaluation`
          } 
          else{  
          url = `/ReportingEmployees/employee-evaluation-trainee?EmployeeId=${empId}`
          }
        }
        else if(empId == this.loggedInUserObj.empId){
          if(data.Description.includes("evaluated")){
            url = `/evaluation`
          }
          else{
            url = `/my-timesheets?calenderDate=${fromDate}`
          }
        }else{
          url = `/employer-timesheets?searchText=${email}&calenderDate=${fromDate}`
        }
      }
      if(url != "") {
        window.open(url, "_self")
      }
    },
    fetch() {
      this.isLoading = true;
      var orgId =  this.loggedInUserObj != null ? this.loggedInUserObj.orgId : "";
      ajax.put(`/Notification/List?pageNo=0&pageSize=5&empOrgId=${orgId}`, {}, (res) => {
        this.isLoading = false;
       // this.notificationList = res.data.Notifications;
          var result = res.data.Notifications.map(function(el) {
            var o = Object.assign({}, el);
            o.Loadmore = true;
            return o;
          })
        this.List = result
        this.notificationList = result
      });
    },
    onClose() {
      this.$emit('update:show', false);
    },
    onRedirectAndClose() {
      this.$router.push({'name': 'notification'});
      this.onClose();
    },
    markAsRead(notificationId) {
      ajax.post(`/Notifications/MarkNotificationAsRead?notificationId=${notificationId}`, {}, (res) => {
        this.fetch();
        let notificationCount = this.$store.getters.getUnreadNotificationsCount;
        notificationCount--;
        this.$store.commit('updateUnreadNotificationsCount', notificationCount);
      })
    }
  }
}
</script>
<style>
.Notification-viewmore > a {
  color: #498fe1 !important;
  font-weight: 500;
  font-size: 10px;
  line-height: 18px;
  display: block;
}
</style>
<style scoped>
.notification-bell {
  position: fixed;
  top: 50px;
  right: 0;
  background: #fff;
  z-index: 2;
  border: 1px solid #eee;
}
.right-sidebar{
  background:#FDFBFA;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Notification/NotificationBell.vue